import type { PlatformProductStatus } from '~/types/graphql';
import type { BadgeProps } from '@shopify/polaris';

/**
 * Why a Control product can't be tested right now. Also the priority order a banner/tooltip picks one
 * issue by when a product has more than one — a deleted product is unrecoverable, so it always wins
 * over a merely unpublished or draft/archived one.
 */
export const PRICE_PRODUCT_ISSUE = {
  DELETED: 'DELETED',
  UNPUBLISHED: 'UNPUBLISHED',
  DRAFT_OR_ARCHIVED: 'DRAFT_OR_ARCHIVED',
} as const;

export const PRICE_PRODUCT_ISSUE_BANNER_TITLE = "Some products can't be tested";

export const PRICE_PRODUCT_ISSUE_BANNER_MESSAGE = {
  [PRICE_PRODUCT_ISSUE.DRAFT_OR_ARCHIVED]:
    'Some products are set as draft or archived. Change their status to active or select other product to start experiment.',
  [PRICE_PRODUCT_ISSUE.DELETED]: 'Some products are deleted. Replace them to start experiment.',
  [PRICE_PRODUCT_ISSUE.UNPUBLISHED]:
    'Some products are unpublished from online-store channel. Publish them to start experiment.',
} as const;

export const PRICE_PRODUCT_ISSUE_START_TOOLTIP = {
  [PRICE_PRODUCT_ISSUE.DRAFT_OR_ARCHIVED]: 'Active product to start',
  [PRICE_PRODUCT_ISSUE.DELETED]: 'Replace product to start',
  [PRICE_PRODUCT_ISSUE.UNPUBLISHED]: 'Publish product to start',
} as const;

/** Labels for the two issues that aren't a real `PlatformProductStatus` of their own. */
export const PRICE_PRODUCT_ISSUE_BADGE_LABEL = {
  [PRICE_PRODUCT_ISSUE.DELETED]: 'Deleted',
  [PRICE_PRODUCT_ISSUE.UNPUBLISHED]: 'Unpublished',
} as const;

/** A product's own badge once it carries no other issue — Active shows no badge at all. */
export const PRICE_PRODUCT_STATUS_BADGE_LABEL: Record<PlatformProductStatus, string> = {
  ACTIVE: 'Active',
  DRAFT: 'Draft',
  ARCHIVED: 'Archived',
  UNLISTED: 'Unlisted',
};

export const PRICE_PRODUCT_STATUS_BADGE_TONE: Partial<
  Record<PlatformProductStatus, BadgeProps['tone']>
> = {
  DRAFT: 'info',
  UNLISTED: 'new',
};
